import { useAuth } from '../context/AuthContext';

/**
 * useCardOrderPath — zentrale Card-Order-Routing-Logik.
 *
 * Business-Kunden → /gold-card
 * Alle anderen (Privat/Anonym) → /silver-card
 *
 * @returns {{ path: string, isBusiness: boolean, label: string, shortLabel: string }}
 */
export function useCardOrderPath() {
  const { user } = useAuth();
  const isBusiness = user?.user_type === 'business';
  return {
    path: isBusiness ? '/gold-card' : '/silver-card',
    isBusiness,
    label: isBusiness ? 'FuelX Gold Card bestellen' : 'FuelX Silver Card bestellen',
    shortLabel: isBusiness ? 'Gold Card sichern' : 'Silver Card sichern',
  };
}
